module.exports = __webpack_public_path__ + "img/GALERIA-XL7-2021-5.3c1df930.jpg";